import { Button, ButtonGroup } from '@theswing/rhythm';

import { PageContainer } from '@/components/common/PageContainer';

export function Invite() {
  const handleClickApp = () => {
    window.location.href =  `https://theswing.onelink.me/bDAE/ymkei2hp`; 
    // window.location.href = `https://theswing.onelink.me/bDAE/5ketqnkj`; // stage
  };

  return (
    <PageContainer>
      <PageContainer.GhostNavigationBar />
      <PageContainer.Content hasButtonWith={[ 'gradient', 1 ]}
                             isScrollable={true}>
        <img src={'https://cdn.swingmobility.dev/swing_asset/a0e33c7f-4fee-4c68-a447-af75670344fc'}
             style={{ width: '100%' }} />
        <PageContainer.ButtonContainer style={{ background: `linear-gradient(0deg, #000 0%, transparent 100%)` }}>
          <ButtonGroup variant={'1-b'}>
            <Button onClick={handleClickApp}>
              앱 바로가기
            </Button>
          </ButtonGroup>
        </PageContainer.ButtonContainer>
      </PageContainer.Content>
    </PageContainer>
  );
}